/**
 * Shared constants for the alert surfaces: the map's alert feed, the machine
 * alert tables, and the Alerts workspace (queue + history).
 */

/** REST endpoints backing the alert reads. */
export const API_ROUTES = Object.freeze({
  ALERTS: "/api/alerts/",
  ALERTS_MAP: "/api/alerts/map/",
  /** Current operator work — all Pending in scope, cursor-paginated. */
  ALERTS_QUEUE: "/api/alerts/queue/",
  /** Workload + outcome analytics for a scope and period. */
  ALERTS_ANALYTICS: "/api/alerts/analytics/",
  /** Staff-only platform ingest observability. */
  ALERTS_MONITORING: "/api/monitoring/alerts/",
  /** The staff-capability source for gating the monitoring surface. */
  CURRENT_USER: "/users/me/",
});

/**
 * React Query key roots.
 *
 * Queue and History are SEPARATE namespaces on purpose: a queue refresh (or a
 * live-hint invalidation) must not reset history state, and moving the history
 * range must not invalidate queue membership.
 */
export const QUERY_KEYS = Object.freeze({
  ALERTS: "alerts",
  ALERTS_QUEUE: "alerts-queue",
  ALERTS_HISTORY: "alerts-history",
  /** Canonical detail and the timeline never share a cache entry — a failed
   *  refetch of one must not erase the other's last valid response. */
  ALERT_DETAIL: "alert-detail",
  ALERT_ACTIVITIES: "alert-activities",
  /** Analytics is a reporting read — never invalidated by a live hint. */
  ALERTS_ANALYTICS: "alerts-analytics",
  ALERTS_MONITORING: "alerts-monitoring",
  ALERTS_CURRENT_USER: "alerts-current-user",
});
